const pushGaData = (gaData: GaData) => {
  if (window.dataLayer && window.dataLayer.push && gaData) {
    const resolved = {
      event: gaData.event || 'AutoEvent',
      eventCategory: gaData.eventCategory || 'Navigation',
      eventAction: gaData.eventAction,
      eventLabel: gaData.eventLabel
    };
    window.dataLayer.push(resolved);
  }
};

const GaHelper = {
  pushGaData: pushGaData
};
export default GaHelper;
